import React from 'react'
import "./ProductCard.css"
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux';
function ProductCard({ item }) {
  const layout = useSelector((state) => state.layoutRducer.layoutArray);
 
  return (
    <Link to={`/product/${item && item?.id}`} style={{ color:layout&&layout.color4,textDecoration:'none' }}className='mb-2'>
      <div className='product_card_container'>
        <div className='img_container'>
          <img src={item?.images[0]?.image} className='product_img' alt='' />
        </div>

        <div className='mb-3 pb-3 px-2'>
          {/* <p className='product_name mb-2'>{item?.name_ar.length>17?item?.name_ar.substring(0,17)+'...':item?.name_ar}</p> */}

          {/* <p className='product_paragraph mb-0'>Women's Plain Long Sleeve Crew Neck Sweatshirt </p> */}
          <div className='d-flex price_container mb-2'>
            {item?.priceAfterDiscount ?
              <>
                <p className='mb-0 price me-2 text-decoration-line-through'>EGP {Number(item && item?.price_egp).toFixed(0)}</p>
                <p className='mb-0 price_discount'>EGP {Number(item && item?.priceAfterDiscount).toFixed(0)}</p>
              </>
              :
              <p className='mb-0 price_discount'>EGP {Number(item && item?.price_egp).toFixed(0)} </p>


            }

          </div>
          <div className='d-flex price_container justify-content-center'>


    

          </div>

        </div>
      </div>
    </Link>
  )
}

export default ProductCard